import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { KnowledgeSharingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { KnowledgeSharingService } from './api/knowledgeSharing.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class KnowledgeSharingApiModule {
    public static forRoot(configurationFactory: () => KnowledgeSharingConfiguration): ModuleWithProviders<KnowledgeSharingApiModule> {
        return {
            ngModule: KnowledgeSharingApiModule,
            providers: [ { provide: KnowledgeSharingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: KnowledgeSharingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('KnowledgeSharingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
